import { Button, Grid, Group, Header, Input, ISelectOption, Select, Toggle } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { ISftpFilters } from '../../entities';

export interface IProps {
  handleFilterChange: (value: string | boolean | ISelectOption<string>, type: string) => void;
  getClientSelectOptions: (type: string) => ISelectOption<string>[];
  filters: ISftpFilters;
  handleNewSftpUserClick: () => void;
}

export const SftpFilters = ({
  getClientSelectOptions,
  handleFilterChange,
  filters,
  handleNewSftpUserClick,
}: IProps): JSX.Element => {
  const { t } = useTranslation(['common', 'sftpUserManagement']);

  const handleUsernameChange = (value: string): void => {
    handleFilterChange(value ? value : '', 'username');
  };

  const handleEmailChange = (value: string): void => {
    handleFilterChange(value ? value : '', 'email');
  };

  const handleEnabledUsersFilterChange = (value: boolean): void => {
    handleFilterChange(value, 'enabledSftpUsers');
  };

  const getClientChangeHandler = (clientType: string) => (value: ISelectOption<string>): void =>
    handleFilterChange(value ?? '', clientType);

  return (
    <>
      <Header heading={t('userManagement.filter.heading')}>
        <Group>
          <Button variation="primary" onClick={handleNewSftpUserClick}>
            {t('sftpUserManagement:sftpUsers.newSftpUser.button')}
          </Button>
        </Group>
      </Header>

      <Grid columnMaxWidth={{ value: 25, unit: 'rem' }}>
        <Input
          inputTestId="filter-username"
          label={t('userManagement.filter.username.label')}
          ariaLabel={t('userManagement.filter.username.label')}
          placeholder={t('userManagement.filter.username.placeholder')}
          onChange={handleUsernameChange}
          value={filters.username}
          inputId="filter-username"
        />
        <Input
          inputTestId="filter-email"
          label={t('userManagement.filter.email.label')}
          ariaLabel={t('userManagement.filter.email.label')}
          placeholder={t('userManagement.filter.email.placeholder')}
          onChange={handleEmailChange}
          value={filters.email}
          type="email"
          inputId="filter-email"
        />
        {['group', 'brand', 'site'].map(type => (
          <Select
            key={type}
            ariaLabel={t(`userManagement.filter.${type}.label`)}
            label={t(`userManagement.filter.${type}.label`)}
            placeholder={t(`userManagement.filter.${type}.placeholder`)}
            value={filters[type]}
            options={getClientSelectOptions(type)}
            onChange={getClientChangeHandler(type)}
            clearable={true}
            inputId={`filter-${type}`}
            minLength={3}
            minLengthPlaceholder={t('common.minLengthPlaceholder', {
              minLength: 3,
            })}
            noOptionsPlaceholder={t('common.noOptionsPlaceholder')}
          />
        ))}
      </Grid>

      <Grid columnMaxWidth={{ value: 20, unit: 'rem' }}>
        <Toggle
          data-testid="filter-enabled"
          ariaLabel={t('userManagement.filter.enabled')}
          label={t('userManagement.filter.enabled')}
          checked={filters.enabledSftpUsers}
          onChange={handleEnabledUsersFilterChange}
          inputId="filter-enabled"
        />
      </Grid>
    </>
  );
};

export default SftpFilters;
